/**
 * Possible order statuses returned by the API,
 * mapped to display labels and timeline step numbers.
 */
export const ORDER_STATUSES = {
  pending:    { label: 'Order Placed',     step: 1 },
  confirmed:  { label: 'Confirmed',        step: 2 },
  processing: { label: 'Being Prepared',   step: 3 },
  shipped:    { label: 'Out for Delivery', step: 4 },
  delivered:  { label: 'Delivered',        step: 5 },
  cancelled:  { label: 'Cancelled',        step: 0 },
};

export const TIMELINE_STEPS = [
  { step: 1, label: 'Order Placed'     },
  { step: 2, label: 'Confirmed'        },
  { step: 3, label: 'Being Prepared'   },
  { step: 4, label: 'Out for Delivery' },
  { step: 5, label: 'Delivered'        },
];
